import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Calculator } from "lucide-react";
import PrazoCalculatorForm from "@/components/PrazoCalculatorForm";

// Modal da Calculadora de Prazos, aberto a partir de "Para validar" (botão no cabeçalho,
// ou o atalho no card "Conferir ata"). A lógica do formulário em si mora em
// `PrazoCalculatorForm.jsx` (Lote 44) — reaproveitada também na aba própria da
// calculadora, `PrazoCalculatorPage.jsx`.
export default function PrazoCalculator({ open, onOpenChange, initial }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <Calculator className="w-5 h-5 text-emerald-brand" strokeWidth={2} />
            Calculadora de prazos
          </DialogTitle>
        </DialogHeader>
        {/* resetKey no formato "open + data/área do pré-preenchimento": reinicia o
            formulário toda vez que o modal reabre, evitando carregar o cálculo anterior. */}
        <PrazoCalculatorForm
          initial={initial}
          resetKey={open ? `${initial?.data_ato || ""}|${initial?.case_area || ""}` : "closed"}
        />
      </DialogContent>
    </Dialog>
  );
}
